import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Material Icons
import { Delete, Edit } from "@mui/icons-material";

//Local components
import ModalWindow from "../Modal";
import SetClientDrawer from "../drawers/SetClientDrawer";

export default function ClientInfo({ data }) {
  // ==========> Component States <==========
  //State for loading in delete request
  const [isLoading, setIsLoading] = useState(false);
  //State for error in delete request
  const [isError, setIsError] = useState(false);
  //Open modal for delete confirmation/response
  const [openModal, setOpenModal] = useState(false);
  //State for open edit-client drawer
  const [openClientDrawer, setOpenClientDrawer] = useState(false);

  // ==========> Component Functions <==========
  //Function to remove client
  const removeClient = async () => {
    setOpenModal(false);
    setIsLoading(true);
    try {
      const res = await fetchWithTokenJSONPost("/clients/delete", {
        id: data.id,
      });
      const jsonResponse = await res.json();
      if (jsonResponse.status === "ok") {
        window.location.href = "/clients";
      }
    } catch (error) {
      setIsError(true);
    }
    setIsLoading(false);
  };

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <SetClientDrawer
          open={openClientDrawer}
          setOpen={setOpenClientDrawer}
          getData={() => {}}
          existingClientData={data}
          isNewClient={false}
        />
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información del cliente
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold">
            {data.name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Tipo de identificación
            </Typography>
            <Typography variant="body2">{data.type}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Número de identificación
            </Typography>
            <Typography variant="body2">
              {data.idDocument || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Correo electrónico
            </Typography>
            <Typography variant="body2">
              {data.email || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Número de teléfono
            </Typography>
            <Typography variant="body2">
              {data.phoneNumber || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Dirección y otras señas
            </Typography>
            <Typography variant="body2">
              {data.address || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Provincia
            </Typography>
            <Typography variant="body2">
              {data.province || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              País
            </Typography>
            <Typography variant="body2">
              {data.country || "Sin asignar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="right">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <Button
              variant="contained"
              size="small"
              color="secondary"
              sx={{ color: "white" }}
              endIcon={<Edit />}
              onClick={() => {
                setOpenClientDrawer(true);
              }}
            >
              Editar usuario
            </Button>
            {isLoading ? (
              <CircularProgress size={25} />
            ) : (
              <Button
                variant="contained"
                size="small"
                color="error"
                sx={{ color: "white" }}
                endIcon={<Delete />}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Remover usuario
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        leftText="Cancelar"
        leftClick={() => {
          setOpenModal(false);
        }}
        rightText="Sí, Remover"
        rightColor="error"
        rightClick={removeClient}
        title="Remover cliente"
        text="¿Desea remover este cliente permanentemente del registro?"
      />
      <ModalWindow
        isOpen={isError}
        handleClose={() => {
          setIsError(false);
        }}
        leftText="Ok"
        leftClick={() => {
          setIsError(false);
        }}
        title="No se pudo realizar la acción"
        text="No se pudo remover al cliente, por favor intente nuevamente."
      />
    </Card>
  );
}
